import fifthEdition from "./rulesets/fifthEdition";
import pfPlaytest from "./rulesets/pfPlaytest";
import pfrpg from "./rulesets/pfrpg";
import pfrpg2 from "./rulesets/pfrpg2";
import solarianConflict from "./rulesets/solarianConflict";
import embersRpg from "./rulesets/embersRpg";

import savageWorlds from "./rulesets/savageWorlds";
import savageEmbers from "./rulesets/savageEmbers";

const freeRulesets = ["5th Edition", "5e24", "PFRPG", "PFRPG2", "Savage Worlds"];
const specialRulesets = ["Solarian Conflict", "Savage Embers", "PF Playtest", "Embers RPG"];

const rulesets = {
  ["5th Edition"]: fifthEdition,
  ["5e24"]: fifthEdition,
  ["PF Playtest"]: pfPlaytest,
  ["PFRPG"]: pfrpg,
  ["PFRPG2"]: pfrpg2,
  ["Savage Worlds"]: savageWorlds,
  ["Solarian Conflict"]: solarianConflict,
  ["Savage Embers"]: savageEmbers,
  ['Embers RPG']: embersRpg,
  freeRulesets: freeRulesets,
  specialRulesets: specialRulesets
};

export default rulesets;
